export default __webpack_public_path__ + "static/media/bground.c02d1c75.jpg";